var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25885 7.81494C9.68449 7.24548 10.2384 6.7844 10.8756 6.46909C11.5128 6.15379 12.2154 5.99315 12.9263 6.00022H17.4678C18.6698 6.00022 19.8226 6.47771 20.6725 7.32763C21.5224 8.17755 21.9999 9.3303 21.9999 10.5323C21.9999 11.7342 21.5224 12.887 20.6725 13.7369C19.8226 14.5868 18.6698 15.0643 17.4678 15.0643H12.9263C11.8831 15.0638 10.872 14.7034 10.0636 14.0439C9.25529 13.3844 8.69922 12.4663 8.48926 11.4444",
    stroke: "#240b3b",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5106 13.2969C15.3007 12.2751 14.7446 11.3569 13.9363 10.6974C13.1279 10.0379 12.1168 9.67753 11.0736 9.677H6.53205C5.33008 9.677 4.17733 10.1545 3.32741 11.0044C2.47748 11.8543 2 13.0071 2 14.2091C2 15.411 2.47748 16.5638 3.32741 17.4137C4.17733 18.2636 5.33008 18.7411 6.53205 18.7411H11.0736C11.6679 18.7421 12.2566 18.626 12.806 18.3994C13.3554 18.1728 13.8547 17.8402 14.2755 17.4204C14.4303 17.2695 14.5703 17.104 14.6935 16.9264",
    stroke: "#240b3b",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChain);
export default __webpack_public_path__ + "static/media/chain.5efbbce24b71b8ad62bd671415b8e10f.svg";
export { ForwardRef as ReactComponent };